<template>
    <div class="body"> 
      
    <div class="container">

       <!-- 二级菜单切换 -->
     <div v-if="!otherType" class="mainbody menus">
      <a  href="/home"><i class="el-icon-s-home"></i></a> / <a style="color: #666;">学习贯彻党的二十届四中全会精神</a>
    </div>

    <div v-if="!!otherType" class="mainbody menus">
      <a  href="/home"><i class="el-icon-s-home"></i></a> / <a style="color: #666;"> 树立和践行正确政绩观学习教育专栏</a>
    </div>
      
       <div class="content-news">
                <div v-for="(item, index) in newsList" :key="index" class="list-news"  @click="navigateToDetail(item.id)">
                        <!-- <h3 class="news-title">{{ item.title }}</h3> -->
                        <!-- <div class="news-detail" v-html="item.articleData.content"></div> -->
                        <!-- <p class="news-time">{{ item.publishDate}}</p> -->
                    <!-- <hr class="custom-hr"> -->
                     <div class="newCss0" > 
                      <span class="dotSpan" style="float: left;" v-if="60>item.title.length"> {{ item.title }}</span>
                      <span class="dotSpan" style="float: left;" v-else> {{ item.title.substring(0,60) }}...  </span>
                      <span class="timeSpan" style="float: right;"> {{ item.publishDate.substring(0,10)}}</span>
                      
                     </div>
                </div>
                </div>

                  <div class="change_page" >
                <!-- 首页按钮 -->
                <el-button 
                  class="pagination-btn first-last"
                  :disabled="currentPage === 1"
                  @click="handleFirstPage">
                  首页
                </el-button>

                <!-- 分页组件 -->
                <el-pagination
                  layout="prev, pager, next"
                  :total="totalNum"
                  :page-size="pageSize1"
                  :current-page="currentPage"
                  background
                  @current-change="pageChange"
                />

                <!-- 末页按钮 -->
                <el-button 
                  class="pagination-btn first-last"
                  :disabled="currentPage >= totalPage"
                  @click="handleLastPage">
                  末页
                </el-button>
              </div>
    </div>
</div>
  </template>
  
  <script>
    import API from '@/api/index'
  
  export default {
    data() {
      return {
        otherType:null,
        currentPage:1,
        pageSize1:9,
        totalNum:null,
        imgList: [],
        newsList:[],
        urlBase: process.env.VUE_APP_BASE_API

      }
    },
    
    mounted() {
       this.otherType = this.$route.query.otherType
       

       this.getList()    // 左侧轮播图
     
     },
    methods: {
     pageChange(page) {
  this.currentPage = page;
  this.getList();
},
handleFirstPage() {
      if (this.currentPage !== 1) {
        this.pageChange(1)
      }
    },
    handleLastPage() {
      const last = this.totalPage
      if (this.currentPage !== last) {
        this.pageChange(last)
      }
    },    

          // 获取右侧新闻
      async getList() {
        try {
       //  materials/a/cms/api/getArticleById?catId=71&pageNum=1&pageSize=9
          let paramsObj={
            catId:!this.otherType?'71':this.otherType,
            pageSize:this.pageSize1,
            pageNum:this.currentPage
        }
        
          const res = await API.getArticleById(paramsObj)
           this.newsList=res.data.artList
           debugger
            this.totalNum = res.data.totalNum;
            this.totalPage=res.data.totalPage
          } catch (error) {
          }
        },
        navigateToDetail(articleId){
      // const encodedTitle = encodeURIComponent(currentPanel.explains)
     
          // this.$router.push({
          //   path: '/newsDetailHome',
          //   query: {                     
          //     artId: articleId 
          //   }
          // })
          if(!this.otherType){
             window.open('/newsDetailHome?artId='+articleId+'&zl=1', '_blank');
          }else{
              window.open('/newsDetailHome?artId='+articleId+'&zl=1&otherType='+this.otherType, '_blank');
          }
         
        }
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .body{
    background-color: #ffffff ;

  }
  .container {
    width: 90%;
    margin: 0 auto;
    // padding-top: 7vh;
    position: relative;
    transition: all .4s ease;
    }
    .bigTitleOne {
    
    line-height: 6rem;
    color: #333;
    text-align: center;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
   
    // margin-bottom: 3vh;
    }
    
    .firstCon{
      width:100%;
      height:100%;
      display: flex;
      @media screen and (max-width: 768px) {
        flex-direction: column;;
      }
    }
    .oneCon{
      width:50%;
      flex: 50%;
      @media screen and (max-width: 768px) {
          width:100%;
      }
     
    }
    .twoCon{
      margin-left: 2%;
      width:48%;
      display: inline-block; 
      box-shadow: 0 1px 12px rgba(3, 3, 3, 0.16);
      // @media (min-width: 0px) and (max-width: 991px) {
      //   width:100%;
      //   margin-left: 0;
      //   display: block; 
      //   margin-top:2rem
      // } 
      @media screen and (max-width: 768px) {
          width:100%;
      }
    }
    .el-carousel-item{
        // width:100%;
        height: 100%;
    }
    .carousel-item {
      display: flex; /* 使用Flex布局 */
      height: 100%; /* 确保项目高度为100% */
    }
  .tips_newsfont {
    width:100%;
    position: absolute;
    bottom: 0;
    // left: 300px;
    z-index: 5;
    color: #fff;
    @media screen and (max-width: 768px) {
    }
    background: rgba(24, 90, 171, 0.6);
  }
  .tips_newsfont p{
    padding:2vh 1vh;
    font-size: 1.4vh;
    line-height: 1.8vh;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right:9vh
  }
  .pic_item{
    width:100%;
      height: 100%;
      object-fit: cover;
  }
  @keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%); /* 元素从左边开始，超出可视区域 */
    opacity: 0; /* 初始时不可见 */
  }
  100% {
    transform: translateX(0); /* 元素到达正常位置 */
    opacity: 1; /* 完全可见 */
  }
}
 
.first-left {
  // animation: slideInFromLeft 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
  /*指示器*/
.first-left .el-carousel__indicators {
left: unset;
  transform: unset;
  right: 2%;
  bottom:2.4%
}
 /*指示器按钮*/ 
 
 
 .first-left .el-carousel__button {
   width: 1vh;
  height: 1vh;
  border: none;
  border-radius: 50%;
  background-color: #fff;
}
/*指示器激活按钮*/
.first-left .is-active .el-carousel__button {
  background: #015293;
}
 
.first-left .el-carousel__container {
  height: 100%;
}
@keyframes slideInFromRight {
  0% {
    transform: translateX(100%); /* 元素从左边开始，超出可视区域 */
    opacity: 0; /* 初始时不可见 */
  }
  100% {
    transform: translateX(0); /* 元素到达正常位置 */
    opacity: 1; /* 完全可见 */
  }
}
 
.content-news {
  // animation: slideInFromRight 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
  .content-news{
    width: 90vw;
   
    padding-top: 0.8rem;
    // border-radius: 1rem;
    overflow-y: hidden;
    background-color: #fff;
    @media screen and (max-width: 768px) {
      // height:50vh;
    }

  }
  .list-news{
    // height:16vh;
    // padding:1rem 1rem 0.6rem 2rem;
    height:3.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    line-height:3.5rem;
    // padding-bottom: 0;
    overflow: hidden; /* 关键属性：隐藏超出部分 */
    border-bottom: 1px solid #eee;
    color: #333333;

  }
  .list-news:hover {
    background-color: #015293;
   
    *{
      color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
    }
  }
  // .list-news:hover div{
  //   background-color: #015293!important;
  //   color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
  // }
  .list-news:last-child{
    border-bottom:none;

  }
  .news-title{
    font-size: 1.1rem;
    // margin-bottom: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  .news-detail{
    height: 4.4vh; /* 假设行高大约是1.2em */
    overflow: hidden;
    // padding-top:5px;
    background-color: none!important;

  }
  :v-deep .news-detail p{
    background-color:transparent !important;
    font-size: 1.2vw!important;
    line-height:1.2vw!important;
    // margin-bottom: 1vh;
     
  }
  :v-deep .news-detail p span{
    all:unset;
    font-size: 1.2vw!important;
    line-height: 1.2vw!important;
    background-color: none!important;
    
  }
  .news-detail p span{
    @media screen and (max-width: 768px) {
      font-size: 1rem !important;
    }
  }
  

  :v-deep .news-detail p span span{
    all:unset;
    font-size: 1.2vh!important;
    line-height:1.2vw!important;
    background-color: none!important;
    color:red;
   
  }
 .news-detail p{
    background-color:transparent !important;
  }
  :v-deep  .news-detail p{
    font-size: 1.2vh!important;
    line-height:1.2vw!important;
   
  }



  .news-time{
    padding-top:1vh;
    font-size: 0.9rem;
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  </style>
    <style lang="scss" scoped> 
    .container {
      min-height: 70vh !important;
      padding-top: 5vh !important;
      position: relative;
      transition: all .4s ease;
      @media screen and (max-width: 768px) {
          padding-top: 0vh !important;
          min-height: 50vh !important;
        }
    }
    .Hcssy{
      height: 24rem;
      overflow: hidden;
      @media screen and (max-width: 768px) {
        height: 26vh;
      }
    }
    .newCss0{
      clear: both;
      font-size: 2.5vh;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        font-size: 2vh;
      }
    }
  
    .timeSpan{
      font-size: 0.9rem;
      color: #999999;
    }
   


    </style>